import { FileTextIcon, ZapIcon, ActivityIcon, SmartphoneIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% PDF Visuel'
}, {
  icon: ZapIcon,
  label: 'Téléchargement immédiat'
}, {
  icon: ActivityIcon,
  label: 'Tous niveaux'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export const heroTrust = [{
  icon: ShieldCheckIcon,
  label: 'Garantie 7 jours'
}, {
  icon: LockIcon,
  label: 'Paiement sécurisé'
}, {
  icon: CreditCardIcon,
  label: 'Crédit / Débit'
}, {
  icon: ZapIcon,
  label: 'Accès instantané'
}];
export const stats = [{
  value: "500+",
  label: "Professionnels satisfaits"
}, {
  value: "6+5",
  label: "Volumes + Bonus"
}, {
  value: "99%",
  label: "Ils le recommandent."
}, {
  value: '4.9/5',
  label: "⭐ Note globale"
}];